import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from "@angular/common/http";
import { Observable } from "rxjs";
import {
  SYS_SERVICE_URL,
  USETOKENAUTHEN,
  INVARIANT,
  ENVIRONMENT,
} from "../../../config";
import { GlobalState } from "../app/global/app.global";
import { EncryptionSerProvider } from "../encryption";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private global: GlobalState,
    private encySer: EncryptionSerProvider,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const baseUrl =
      req.headers.get("JointBaseUrl") === "true"
        ? ENVIRONMENT === "debug"
          ? SYS_SERVICE_URL.debug_base_url
          : SYS_SERVICE_URL.base_url
        : "";
    const newReq = {
      url: baseUrl + req.url,
      headers: req.headers.set("device", "PHONE"),
    };
    // newReq.headers = newReq.headers.append('Access-Control-Allow-Origin', '*');//跨域设置
    console.log(newReq.headers);
    const token = this.global.state.userInfo
      ? this.global.state.userInfo.token
      : false;
    if (
      req.headers.get("WithSecurityToken") === "true" &&
      USETOKENAUTHEN &&
      token
    ) {
      const authToken = this.encySer.generateSecurityId(req.url, token);
      newReq.headers = newReq.headers.set(INVARIANT._REQUEST_TOKEN, authToken);
      newReq.headers = newReq.headers.set("Access-Control-Allow-Origin", "*");
    }
    token && (newReq.headers = newReq.headers.set("token", token));
    newReq.headers = newReq.headers.delete("WithSecurityToken");
    newReq.headers = newReq.headers.delete("JointBaseUrl");
    const convertReq = req.clone(newReq);
    return next.handle(convertReq);
  }
}



// WEBPACK FOOTER //
// ./src/services/common/http/auth-interceptor.ts